const LOCATION_CHANGE_EVENT = 'location_change';
const subscribers = new Set<() => void>();
let isHistoryObserverInstalled = false;

export function subscribeToPageChange(track: (url: string) => void) {
  let previousTrackedUrl = '';

  // Multiple analytics clients can subscribe, but history must only be patched
  // once per browser process.
  if (!isHistoryObserverInstalled) {
    installHistoryObserver();
    isHistoryObserverInstalled = true;
  }

  const notify = () => {
    const currentUrl = window.location.href;

    if (currentUrl !== previousTrackedUrl) {
      track(currentUrl);
      previousTrackedUrl = currentUrl;
    }
  };

  subscribers.add(notify);
  return () => {
    subscribers.delete(notify);
  };
}

function installHistoryObserver() {
  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  });

  window.addEventListener('hashchange', function () {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  });

  const nativePushState = window.history.pushState;
  if (typeof nativePushState === 'function') {
    window.history.pushState = function (state, unused, url) {
      nativePushState.call(window.history, state, unused, url);
      window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
    };
  }

  const nativeReplaceState = window.history.replaceState;
  if (typeof nativeReplaceState === 'function') {
    window.history.replaceState = function (state, unused, url) {
      nativeReplaceState.call(window.history, state, unused, url);
      window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
    };
  }

  window.addEventListener(LOCATION_CHANGE_EVENT, function () {
    for (const notify of subscribers) {
      notify();
    }
  });
}
